import { AngularServices, DocumentVisibilityStates, } from '../../../modules/core';
import EventEmitter from '../../../utility/event-emitter';
import { selectors } from '../../../modules/local-media';
const PUBLISHER_MEDIA_AVAILABILITY_CHECK_INTERVAL = 4000;
const PUBLISHER_MEDIA_AVAILABILITY_CHECK_THRESHOLD = 2;
export var MediaIssueType;
(function (MediaIssueType) {
    MediaIssueType["audioBroken"] = "audioBroken";
    MediaIssueType["videoBroken"] = "videoBroken";
    MediaIssueType["mediaBroken"] = "mediaBroken";
})(MediaIssueType || (MediaIssueType = {}));
export var PublisherMediaWatcherEvents;
(function (PublisherMediaWatcherEvents) {
    PublisherMediaWatcherEvents["Error"] = "error";
})(PublisherMediaWatcherEvents || (PublisherMediaWatcherEvents = {}));
const extractTrackState = (track, kind) => {
    if (!track) {
        return { kind, track: false };
    }
    return {
        kind,
        track: true,
        enabled: track.enabled,
        muted: track.muted,
        readyState: track.readyState,
    };
};
const isUnavailable = (state) => {
    if (!state.track ||
        !state.enabled ||
        state.muted ||
        state.readyState === 'ended') {
        return true;
    }
    return false;
};
const convertToMediaIssue = (state, seqNumber) => {
    return { ...state, number: seqNumber + 1 };
};
export class PublisherMediaWatcher extends EventEmitter {
    constructor($injector) {
        super();
        this.$injector = $injector;
        this.$ngRedux = this.$injector.get('$ngRedux');
    }
    start() {
        let videoIssues = [];
        let audioIssues = [];
        const factory = this.$injector.get(AngularServices.VideoProviderFactory);
        setInterval(() => {
            if (!factory.activeProvider)
                return;
            if (document.visibilityState === DocumentVisibilityStates.Hidden) {
                return;
            }
            const publisher = factory.activeProvider.getPublisher();
            if (!publisher || factory.activeProvider.isPublisherLoading)
                return;
            const { hasVideo, hasAudio } = selectors.mediaAvailability(this.$ngRedux.getState());
            if (hasVideo) {
                const video = publisher.getVideoSource().track;
                const videoState = extractTrackState(video, 'video');
                if (isUnavailable(videoState)) {
                    videoIssues.push(videoState);
                }
                else {
                    videoIssues = [];
                }
            }
            else {
                videoIssues = [];
            }
            if (hasAudio) {
                const audio = publisher.getAudioSource();
                const audioState = extractTrackState(audio, 'audio');
                if (isUnavailable(audioState)) {
                    audioIssues.push(audioState);
                }
                else {
                    audioIssues = [];
                }
            }
            else {
                audioIssues = [];
            }
            if (videoIssues.length === PUBLISHER_MEDIA_AVAILABILITY_CHECK_THRESHOLD ||
                audioIssues.length === PUBLISHER_MEDIA_AVAILABILITY_CHECK_THRESHOLD) {
                const mediaIssueType = videoIssues.length === audioIssues.length
                    ? MediaIssueType.mediaBroken
                    : videoIssues.length > audioIssues.length
                        ? MediaIssueType.videoBroken
                        : MediaIssueType.audioBroken;
                this.emit(PublisherMediaWatcherEvents.Error, {
                    mediaIssueType,
                    mediaIssues: [
                        ...videoIssues.slice(-2).map(convertToMediaIssue),
                        ...audioIssues.slice(-2).map(convertToMediaIssue),
                    ],
                });
            }
        }, PUBLISHER_MEDIA_AVAILABILITY_CHECK_INTERVAL);
    }
}
